import Modal from 'react-bootstrap/Modal'
import Container from '@material-ui/core/Container';

import WarningPerson from '../../../assets/images/error-person-icon.svg';
import IsvLogo from '../../../assets/images/isv.svg';


const ConfirmModal = ({
    showModal,
    handleClickOKModal,
    handleClickCancelModal,
}) => {
    const handleButtonOK = (e) => {
        e.preventDefault();
        handleClickOKModal(e);
    };

    const handleButtonCancel = (e) => {
        e.preventDefault();
        handleClickCancelModal();
    };

    return (
        <Modal
            size="md"
            show={showModal}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Body>
                <Container>
                    <br />
                    <div className="row d-flex justify-content-center" style={{ textAlign: 'justify' }}>
                        <img src={IsvLogo} alt="isv-logo" style={{ width: 210 }} />
                    </div>
                    <br />
                    <br />
                    <br />
                    <div className="row d-flex justify-content-center" style={{ textAlign: 'justify' }}>
                        <img src={WarningPerson} alt="warning-person" />
                    </div>
                    <br />
                    <br />
                    <div className="row justify-content-center">
                        <h2 className="title-7">
                            <b>¡Advertencia!</b><br />
                            <b className="title-7 title-bold">¿Ya ingresaste todas las cadenas?</b>
                        </h2>
                    </div>
                    <div className="row justify-content-center">
                        <span className="text-3">
                            Al continuar no podrás volver a ingresar cadenas por este medio.
                        </span>
                    </div>
                    <br />
                    <br/>
                    <div className="row justify-content-end">
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <button
                                className="isv-btn isv-btn-circle btn-light btn-size btn-block"
                                onClick={handleButtonCancel}
                            >
                                Seguir ingresando claves
                            </button>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <button
                                className="isv-btn isv-btn-circle btn-warning btn-size btn-block m-top"
                                onClick={handleButtonOK}
                            >
                                Continuar
                            </button>
                        </div>
                    </div>
                    <br />
                    <br/>
                </Container>
            </Modal.Body>
        </Modal>
    );
};

export default ConfirmModal;
